import { useEffect } from 'react';

export function useTokenizedTheme() {
  useEffect(() => {
    const root = document.documentElement;

    // Apply DESIGN.md Nordic dark-first tokens (calm teal accent, dark surfaces)
    // Do not override core --background etc (those live in index.css :root for shadcn)
    // Primary accent scale (teal/sage per DESIGN)
    root.style.setProperty('--accent', '#0f766e');
    root.style.setProperty('--accent-light', '#14b8a6');
    root.style.setProperty('--primary', '#0f766e');

    // Semantic (restrained, match index.css)
    root.style.setProperty('--success', '#10b981');
    root.style.setProperty('--warning', '#f59e0b');
    root.style.setProperty('--destructive', '#ef4444');
    root.style.setProperty('--info', '#64748b');

    // Note: full surface tokens (--background, --card, --foreground, --border, --ring) are authoritative in src/index.css
    // This hook only augments for components that read the design-system/tokens shape or --primary-*
    console.log('Design tokens (DESIGN.md Nordic) applied via useTokenizedTheme');
  }, []);
}
